export enum ProfileStatus {
  UpdateRequired = "UpdateRequired",
  NotStarted = "NotStarted",
  InProgress = "InProgress",
  DetailsPending = "DetailsPending",
  Completed = "Completed",
}

export type ProfileStatusBadgeProps = {
  status?: ProfileStatus;
};
